import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import Button from '../Button';
import { PHONE_AUTH_MODAL } from '../../../constants/modals';
import { openModal } from '../../../actions/modal-actions';
import { myMatchesButtonAlbumMembershipGroup } from './graphql';
import { albuMembershipGroupHasJoinedIdentities } from './helpers';

const propTypes = {
  albumFolderId: PropTypes.string.isRequired,
  login: PropTypes.func.isRequired,
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  authenticated: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  // Whether the button should be hidden if the user has no entitled content.
  disableWithoutEntitlement: PropTypes.bool,
  disableIfJoined: PropTypes.bool,
};

const MyMatchesButton = ({
  albumFolderId,
  albumMembershipGroup,
  albumMembershipGroupId,
  loading,
  history,
  login,
  children,
  disableWithoutEntitlement = false,
  authenticated,
  disableIfJoined = false,
  ...props
}) => {
  if (loading) {
    return null;
  }

  const hasJoinedIdentities = albuMembershipGroupHasJoinedIdentities(
    albumMembershipGroup,
  );

  const targetUrl = (() => {
    if (hasJoinedIdentities && !disableIfJoined) {
      return `/app/shutterbug/hierarchy-items/${albumMembershipGroup.id}/matches`;
    }

    if (!hasJoinedIdentities && !disableWithoutEntitlement) {
      return `/discover/album-folder/${albumFolderId}/start?fromGallery=true`;
    }

    return '';
  })();

  if (!targetUrl) {
    return null;
  }

  // The target URLs already have their own login mechanisms.
  const onClick = () => {
    history.push(targetUrl);
  };

  return typeof children === 'function' ? (
    children({
      albumMembershipGroup,
      targetUrl,
      hasJoinedIdentities,
      onClick,
    })
  ) : (
    <Button {...props} onClick={onClick}>
      {children || (hasJoinedIdentities ? 'My Matches' : 'Find My Photos')}
    </Button>
  );
};

export { MyMatchesButton as MyMatchesButtonComponent };

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  login: actionProps =>
    // TODO: Once we have a common login modal for email / phone, would be good to use that one here.
    dispatch(openModal(ownProps.authMode || PHONE_AUTH_MODAL, actionProps)),
});

const withAlbumMembershipGroup = graphql(myMatchesButtonAlbumMembershipGroup, {
  options: ({ albumMembershipGroupId, albumFolderId }) => ({
    variables: {
      // albumFolderId is always required for onboarding purposes
      // but albumMembershipGroupId is either the current Album or AlbumFolder
      // so it takes priority.
      id: albumMembershipGroupId || albumFolderId,
    },
  }),
  props: ({ data: { albumMembershipGroup, loading } = {} }) => ({
    albumMembershipGroup,
    loading,
  }),
  skip: ({ authenticated, albumMembershipGroupId, albumFolderId }) =>
    !authenticated || (!albumMembershipGroupId && !albumFolderId),
});

MyMatchesButton.propTypes = propTypes;

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withAlbumMembershipGroup,
)(MyMatchesButton);
